import { render, staticRenderFns } from "./NavCompactContainer.vue?vue&type=template&id=0468168a&scoped=true&"
import script from "./NavCompactContainer.vue?vue&type=script&lang=js&"
export * from "./NavCompactContainer.vue?vue&type=script&lang=js&"
import style0 from "./NavCompactContainer.vue?vue&type=style&index=0&id=0468168a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0468168a",
  null
  
)

export default component.exports